// Webstrap (Bootstrap)
require("webstrap/type");
require("webstrap/buttons");
require("webstrap/forms");
require("webstrap/alerts");
require("webstrap/code");

// Dependencies for layout
require("grid");

// Styles
require("./base.scss");

// JavaScript
var $ = require("jquery");

// Datepicker demo
require("datepicker");
$('.datefield-demo').datepicker();

// Form validation demo
if ($('.forms-validation-demo').length > 0)
{
    require("forms-validation");
    $('.forms-validation-demo').validate(require("forms-validation/options/defaults.js"));
    $('.forms-validation-demo').valid();
}



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/style-guide/base/index.js
// module id = 262
// module chunks = 0